import {createFileRoute, useParams} from "@tanstack/react-router";

import {routeMessages} from "../../../../../../messages/routes.messages";

import {RepresentativeContactsPage} from "./-page/representative-contacts.page";
import {RepresentativeContactsPending} from "./-page/representative-contacts.pending";
import {representativeContactsSearchSchema} from "./-types";

export const Route = createFileRoute("/_app/sales/representatives/$representativeId/contacts/")({
  component: RouteComponent,
  pendingComponent: RepresentativeContactsPending,
  staticData: {meta: {labelDescriptor: routeMessages.contacts}},
  validateSearch: (search) => representativeContactsSearchSchema.parse(search),
});

function RouteComponent() {
  const {representativeId} = useParams({strict: false}) as {representativeId: string};
  const {includeDeleted} = Route.useSearch();

  return (
    <RepresentativeContactsPage
      includeDeleted={includeDeleted}
      representativeId={representativeId}
    />
  );
}
